import axios from "../../../util/axios";
// 通用接口，有数据权限限制
export default {
    /** 查询供应商列表 */
    queryList: (data) => axios.get({url: "/basedata/partner/supplier/queryList", data}),
    /** 保存供应商信息 */
    saveSupplier: (data) => axios.post({url: "/basedata/partner/supplier/saveSupplier", data}),
    /** 查询明细 */
    findById: (id) => axios.get({url: "/basedata/partner/supplier/findById", data:{id}}),
    /** 删除客户 */
    delete: (id) => axios.del({url: "/basedata/partner/supplier/delete", data:{id}}),
    /** 批量修改分类 */
    updateCategoryBatch: (data) => axios.get({url: "/basedata/partner/supplier/updateCategoryBatch", data}),
    /**导出模板*/
    exportTemp: () => axios.get({url: "/basedata/partner/supplier/exportTemp", }),
}

